import React, { useMemo, useState } from 'react';
import { IconWrapper, StyledDrawer, StyledList } from './styled';
import { DASHBOARD_TYPE, CURRENT_PRODUCT_MODE } from '@utils/constants';
import { useSelector } from 'react-redux';
import { buildUsecases } from './utils';
import {
  isCDNAccountSelector,
  supportedMetricsSelector,
  aiAlertsSensitivitySelector,
} from '@store/common/selectors';
import { dimensionsListSelectorKeyValue } from '@store/common/dimensionList/selectors';
import LightningIcon from '@icons/insights/lightning.svg';
import { ArrowRightOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

export const drilldownDashboardType = {
  AI: DASHBOARD_TYPE.TRENDS_DRILLDOWN,
  EI: DASHBOARD_TYPE.TRENDS_DRILLDOWN,
  APP: DASHBOARD_TYPE.APP_EXPERIENCE_DRILLDOWN,
}[CURRENT_PRODUCT_MODE];

const { baseUrl } = window.conviva;

const Title = () => (
  <div>
    <h3>Preset Usecases</h3>
    <h5 style={{ color: 'rgba(0, 0, 0, 0.45)' }}>
      To quickly get started, choose a preset from the available options. Additionally, you have the
      flexibility to create your own presets using the Save option.
    </h5>
  </div>
);

function UseCases() {
  const [open, setOpen] = useState(false);

  const supportedMetrics = useSelector(supportedMetricsSelector);
  const dimensions = useSelector(dimensionsListSelectorKeyValue);
  const isPartnerAccount = useSelector(isCDNAccountSelector);
  const aiAlertsSensitivities = useSelector(aiAlertsSensitivitySelector);

  const usecaseConfig = useMemo(() => {
    if (supportedMetrics && dimensions) {
      return buildUsecases(supportedMetrics, dimensions, aiAlertsSensitivities);
    }
    return [];
  }, [supportedMetrics, dimensions, aiAlertsSensitivities]);

  if (isPartnerAccount) {
    return null;
  }

  const openDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  return usecaseConfig.length > 0 ? (
    <div>
      <IconWrapper onClick={openDrawer}>
        <LightningIcon />
        <span>Presets</span>
      </IconWrapper>
      <StyledDrawer title={<Title />} placement="left" onClose={onClose} open={open}>
        <div>
          <StyledList
            itemLayout="horizontal"
            dataSource={usecaseConfig}
            renderItem={(item, index) => (
              <Link to={`${baseUrl}/dashboard/preset/${item.key}`} target="_blank">
                <StyledList.Item style={{ cursor: 'pointer' }}>
                  <StyledList.Item.Meta
                    avatar={<ArrowRightOutlined />}
                    title={item.title}
                    description={item.description}
                  />
                </StyledList.Item>
              </Link>
            )}
          />
        </div>
      </StyledDrawer>
    </div>
  ) : null;
}

export default UseCases;
